const formsSelect = () => {
    document.addEventListener("DOMContentLoaded", () => {
        const formMultipleSelect = document.querySelectorAll(".gfield--type-multiselect .gfield_label");

        formMultipleSelect.forEach((input) => {
            input.addEventListener("click", () => {
            const closestSelect = input.nextElementSibling;
        
            if (closestSelect && input) {
                input.classList.toggle('openned');
                closestSelect.classList.toggle('openned');
            }
            });
        });
    });
};

export default formsSelect;
